<template>
    <div>
        <div class="section">
            <h1 class="title is-uppercase">{{ title }}</h1>
        </div>

        <div class="section">
            <b-message v-if="sended.message" type="is-success" has-icon>
                <p v-text="sended.message"></p>
            </b-message>
        </div>

        <div id="website-form" class="section">
            <b-field
                :label="__('strings.website.form.name')"
                label-position="on-border"
                :type="{ 'is-danger': errors.name }"
                :message="errors.name">
                <b-input
                    :placeholder="__('strings.website.form.name')"
                    type="name"
                    name="name"
                    v-model="input.name"
                    @focus="clearError"></b-input>
            </b-field>

            <b-field
                :label="__('strings.website.form.code')"
                label-position="on-border"
                :type="{ 'is-danger': errors.code }"
                :message="errors.code">
                <b-input
                    :placeholder="__('strings.website.form.code')"
                    type="code"
                    name="code"
                    v-model="input.code"
                    @focus="clearError"
                ></b-input>
            </b-field>

            <b-field
                :label="__('strings.website.form.magento_id')"
                label-position="on-border"
                :type="{ 'is-danger': errors.magento_id }"
                :message="errors.magento_id">
                <b-input
                    :placeholder="__('strings.website.form.magento_id')"
                    type="magento_id"
                    name="magento_id"
                    v-model="input.magento_id"
                    @focus="clearError"></b-input>
            </b-field>

            <accordion-section
                v-for="(currency, index) in input.currencies"
                :key="index"
                :title="retailers.find(retailer => retailer.id === currency.retailer_id).name">
                <b-field
                    :type="{'is-danger': errors[`currencies.${index}.currency`]}"
                    :message="errors[`currencies.${index}.currency`]">
                    <b-select
                        :placeholder="__('strings.website.form.currency')"
                        v-model="currency.currency"
                        :name="`currencies.${index}.currency`"
                        @focus="clearError"
                        @input="value => handleOnChangeCurrency(value, index)"
                        expanded>
                        <option
                            v-for="symbol in currencySymbols"
                            :key="symbol.currency"
                            :value="symbol.currency">
                            {{ symbol.currency }}
                        </option>
                    </b-select>
                </b-field>

                <div class="columns">
                    <div class="column">
                        <b-field
                            :label="__('strings.website.form.vat_recharge')"
                            label-position="on-border"
                            :type="{'is-danger':errors[`currencies.${index}.vat_recharge`]}"
                            :message="errors[`currencies.${index}.vat_recharge`]">
                            <b-input :placeholder="__('strings.website.form.vat_recharge')"
                                     type="number"
                                     step="any"
                                     min="0"
                                     name="vat_recharge"
                                     expanded
                                     v-model="currency.vat_recharge"
                                     @focus="clearError"></b-input>
                            <p class="control">
                                <span class="button is-static">%</span>
                            </p>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field
                            :label="__('strings.website.form.company_recharge')"
                            label-position="on-border"
                            :type="{'is-danger':errors[`currencies.${index}.company_recharge`]}"
                            :message="errors[`currencies.${index}.company_recharge`]">
                            <b-input :placeholder="__('strings.website.form.company_recharge')"
                                     type="number"
                                     step="any"
                                     min="0"
                                     name="company_recharge"
                                     expanded
                                     v-model="currency.company_recharge"
                                     @focus="clearError"></b-input>
                            <p class="control">
                                <span class="button is-static">%</span>
                            </p>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field
                            :label="__('strings.website.form.duty')"
                            label-position="on-border"
                            :type="{'is-danger': errors[`currencies.${index}.duty`]}"
                            :message="errors[`currencies.${index}.duty`]">
                            <b-input
                                :placeholder="__('strings.website.form.duty')"
                                type="number"
                                min="0"
                                step="any"
                                name="duty"
                                v-model="currency.duty"
                                expanded
                                @focus="clearError"></b-input>
                            <p class="control">
                                <span class="button is-static">%</span>
                            </p>
                        </b-field>
                    </div>
                </div>


                <div class="columns">
                    <div class="column">
                        <b-field
                            :label="__('strings.website.form.exchange_rate')"
                            label-position="on-border"
                            :type="{'is-danger':errors[`currencies.${index}.exchange_rate`]}"
                            :message="errors[`currencies.${index}.exchange_rate`]">
                            <b-input
                                :placeholder="__('strings.website.form.exchange_rate')"
                                type="number"
                                step="any"
                                min="0"
                                name="exchange_rate"
                                :value="currency.exchange_rate"
                                v-model="currency.exchange_rate"
                                @focus="clearError"
                                expanded
                                disabled></b-input>
                            <p class="control">
                                <span class="button is-static">{{ currency.currency }}</span>
                            </p>
                        </b-field>
                    </div>

                    <div class="column">
                        <b-field
                            :label="__('strings.website.form.exchange_rate_variation')"
                            label-position="on-border"
                            :type="{'is-danger':errors[`currencies.${index}.exchange_rate_variation`]}"
                            :message="errors[`currencies.${index}.exchange_rate_variation`]">
                            <b-input
                                :placeholder="__('strings.website.form.exchange_rate_variation')"
                                type="number"
                                step="any"
                                name="exchange_rate_variation"
                                min="0"
                                max="100"
                                v-model="currency.exchange_rate_variation"
                                @focus="clearError"
                                expanded></b-input>
                            <p class="control">
                                <span class="button is-static">%</span>
                            </p>
                        </b-field>
                    </div>
                    <div class="column is-narrow is-flex is-align-items-center">
                        <b-tooltip
                            :label="__('strings.website.form.exchange_rate_variation_alert_message')"
                            type="is-light is-danger"
                            position="is-left"
                            multilined>
                            <b-icon icon="alert" type="is-danger"></b-icon>
                        </b-tooltip>
                    </div>
                </div>
            </accordion-section>

            <div class="field">
                <b-button
                    tag="button"
                    type="is-primary"
                    class="is-uppercase"
                    :label="__('strings.form.submitButton')"
                    @click.prevent="submit"
                    rounded
                    outlined
                />
            </div>
        </div>
    </div>
</template>

<script>
import AccordionSection from "../partials/AccordionSection";

export default {
    components: {AccordionSection},
    data() {
        return {
            retailers: [],
            currencySymbols: [],
            currencySymbolsRateMap: new Map(),
            input: {
                name: "",
                code: "",
                magento_id: "",
                currencies: []
            },
            errors: {
                name: "",
                code: "",
                magento_id: "",
                currency: []
            },
            sended: {
                message: ""
            },
            item: null
        };
    },
    beforeMount() {
        this.retailers = [
            {
                id: 1,
                name: "SamGP+FL"
            },
            {
                id: 2,
                name: "SamGG"
            }
        ];

        this.errors.currencies = this.retailers.map(retailer => {
            return {
                currency: ""
            };
        });
    },
    mounted() {
        if (
            this.$route.params.hasOwnProperty("routeKey") &&
            this.$route.params.routeKey
        ) {
            axios
                .get("/website/edit/" + this.$route.params.routeKey)
                .then(response => {
                    this.item = response.data;
                    this.input = Object.assign({}, response.data);
                })
                .then(() => {
                    if (
                        this.input.currencies === undefined ||
                        this.input.currencies.length < this.retailers.length
                    ) {
                        this.input.currencies = this.getEmptyCurrencies(
                            this.input.currencies
                        );
                    }
                });
        } else {
            if (
                this.input.currencies === undefined ||
                this.input.currencies.length < this.retailers.length
            ) {
                this.input.currencies = this.getEmptyCurrencies(
                    this.input.currencies
                );
            }
        }

        axios
            .get("/currency-symbols/index")
            .then(response => {
                this.currencySymbols = response.data;
                this.currencySymbols?.forEach(item => {
                    this.currencySymbolsRateMap.set(item?.currency, item);
                });
            })
            .catch(error => console.log(error));
    },
    methods: {
        submit() {
            let method = this.item ? "patch" : "post";
            let url = this.item ? `/update/website/${this.$route.params.routeKey}` : "/store/website";
            axios({method, url, data: this.input})
                .then(response => {
                    let translationKey = this.item ? "messages.model.updated" : "messages.model.created";
                    this.sended.message = this.__(translationKey, {
                        name: this.__("strings.models.website")
                    });

                    if (!this.item) {
                        this.$router.push({
                            name: "model.action",
                            params: {
                                resource: "website",
                                action: "edit",
                                routeKey: response.data.id
                            }
                        });
                    }

                    this.item = Object.assign({}, response.data);
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                })
                .finally(() => {
                    window.scrollTo({top: 0, behavior: "smooth"});
                });
        },
        clearError(event) {
            this.errors[event.target.name] = "";
        },
        handleOnChangeCurrency(value, index) {
            console.log(value, index);
            this.input.currencies[index].exchange_rate = this.currencySymbolsRateMap.get(value).rate;
        },
        getEmptyCurrencies(currentCurrencies) {
            return this.retailers.map(retailer => {
                const oldCurrency = currentCurrencies.find(
                    currCurr => currCurr.retailer_id === retailer.id
                );
                if (oldCurrency !== undefined) {
                    return oldCurrency;
                } else {
                    return {
                        retailer_id: retailer.id,
                        currency: null,
                        base_multiplier: null,
                        exchange_rate: null,
                        exchange_rate_variation: null,
                        duty: null
                    };
                }
            });
        }
    },
    computed: {
        title() {
            let translationKey = this.item ? "strings.website.form.editTitle" : "strings.website.form.title";
            return this.__(translationKey);
        }
    }
};
</script>
